export default ({ request }) => ({
  billCartonTransferBoxFindApi(data = {}) {
    return request({
      url: '/samplemanage/billCartonTransferBox/find',
      method: 'post',
      data
    })
  },

  billCartonTransferListApi(data = {}) {
    return request({
      url: '/samplemanage/billCartonTransfer/list',
      method: 'post',
      data
    })
  },
  billCartonTransferDetailApi(data = {}) {
    return request({
      url: '/samplemanage/billCartonTransfer/detail',
      method: 'post',
      data
    })
  },
  billCartonTransferSaveApi(data = {}) {
    return request({
      url: '/samplemanage/billCartonTransfer/save',
      method: 'post',
      data
    })
  },
  billCartonTransferDelApi(data = {}) {
    return request({
      url: '/samplemanage/billCartonTransfer/del',
      method: 'post',
      data
    })
  },
  billCartonTransferAuditApi(data = {}) {
    return request({
      url: '/samplemanage/billCartonTransfer/audit',
      method: 'post',
      data
    })
  },

})
